// @ts-nocheck
import React from 'react';
import { useSelector } from 'react-redux';

import { ReportingInsightsSection } from '@/modules/reporting/ReportingInsights';
import {
  getHasInsightsPermissions,
  getHasReportingAssistantPermissions,
  getSectionsVisibility
} from '@/store/selectors/reporting.selectors';
import { GeneralFilters } from '@/ts-modules/reporting/GeneralFilters';
import { ReportingMap } from '@/ts-modules/reporting/Map';
import { Summary } from '@/ts-modules/reporting/Summary';
import { ReportingProgress } from '../Progress';
import { ReportingAssistantChat } from '../ReportingAssistantChat';
import StatsTablesContent from '../StatsTablesSection/StatsTablesContent';
import { useReporting } from './ReportingContext';

function ReportingContent() {
  const {
    reporting: {
      cartography,
      changeLogData,
      currentCurrency,
      selectedCampaigns,
      selectedCampaignsIds,
      stats,
      user,
      userRoles
    }
  } = useReporting();

  const isStatsReady = Boolean(Object.keys(stats).length);
  const hasInsightsPermission = useSelector(getHasInsightsPermissions);
  const hasAIAssistantPermission = useSelector(getHasReportingAssistantPermissions);
  const sectionsVisibility = useSelector(getSectionsVisibility);

  const isReportingReady = selectedCampaignsIds.length > 0 && userRoles.length > 0 && cartography.length > 0;
  if (!isReportingReady) {
    return null;
  }

  return (
    <article className="reportingContent">
      <GeneralFilters initialCurrency={currentCurrency} />
      <div
        className="reportingBox"
        style={{
          display: !sectionsVisibility.reportingOverview ? 'none' : 'block'
        }}
      >
        <Summary filterSection="summary" />
      </div>
      <div
        className="reportingBox"
        style={{
          display: !sectionsVisibility.reportingCharts ? 'none' : 'block'
        }}
      >
        {isStatsReady && changeLogData && <ReportingProgress />}
      </div>
      {isStatsReady && hasInsightsPermission && (
        <div
          className="reportingBox"
          style={{
            display: !sectionsVisibility.reportingInsights ? 'none' : 'block'
          }}
        >
          <ReportingInsightsSection filterSection="general" />
        </div>
      )}
      {isStatsReady && <StatsTablesContent />}
      {hasAIAssistantPermission && (
        <ReportingAssistantChat
          campaigns={selectedCampaigns}
          currency={currentCurrency}
          user={user}
          userRoles={userRoles}
        />
      )}
      <ReportingMap />
    </article>
  );
}

export default ReportingContent;
